<script lang="ts">
  import { fly } from 'svelte/transition';
  import { cubicOut } from 'svelte/easing';

  export let message: string;
  export let duration: number;

  let visible = false;

  export function show(newMessage: string, newDuration: number) {
    message = newMessage;
    duration = newDuration;
    visible = true;
    setTimeout(() => {
      visible = false;
    }, duration);
  }
</script>

{#if visible}
  <div
    class="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 px-3 py-1 rounded shadow-md text-gray-700 bg-gray-100 max-w-xs pointer-events-none text-sm"
    transition:fly={{ y: 20, duration: 400, easing: cubicOut }}
  >
    {message}
  </div>
{/if} 